// ── 업무/기능 배정 현황 조회 훅 ─────────────────────────────────────────────
import { useCallback, useEffect, useMemo, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';
import { useTenantMenuInfo } from '../adminlayout/tenantMenuInfo';
import { relabelCallTasks } from './callTaskLabels';

function apiPrefix(isDelegate) {
  return isDelegate ? '/api/sub' : '/api/admin';
}

export function useAssignmentOverview({ isDelegate }) {
  const { showToast } = useToast();
  const [overview, setOverview] = useState(null);
  const [overviewLoading, setOverviewLoading] = useState(false);

  const fetchOverview = useCallback(async () => {
    setOverviewLoading(true);
    const result = await apiClient.get(`${apiPrefix(isDelegate)}/work-feature-assignments/overview`);
    setOverviewLoading(false);

    if (!result.ok) {
      showToast(result.data?.message || '업무/기능 배정 현황을 불러오지 못했습니다.', 'error');
      return false;
    }

    setOverview(result.data || {});
    return true;
  }, [isDelegate, showToast]);

  useEffect(() => {
    fetchOverview();
  }, [fetchOverview]);

  // 일일콜 관리 이름을 보는 사람 테넌트 기준 '메뉴명 (회사명)'으로 (2026-09-24, callTaskLabels.js). 모르면 원본.
  const tenantInfo = useTenantMenuInfo();
  const labeled = useMemo(() => relabelCallTasks(overview, tenantInfo), [overview, tenantInfo]);

  return {
    overview: labeled,
    overviewLoading,
    refreshOverview: fetchOverview,
  };
}
